async function createRelativeTime(attributes) {
    const relativeTimeElement = new window.RelativeTimeElement();

    if (attributes.format) {
        relativeTimeElement.format = attributes.format;
    }

    if (attributes.hour && attributes.minute && attributes.second) {
        relativeTimeElement.hour = attributes.hour;
        relativeTimeElement.minute = attributes.minute;
        relativeTimeElement.second = attributes.second;
    }

    relativeTimeElement.precision = 'second';
    relativeTimeElement.datetime = attributes.datetime;

    await Promise.resolve();

    return relativeTimeElement.shadowRoot.textContent;
}

const createAndApplyRelativeTime = (settings, view) => createRelativeTime(settings).then(relativeTimeText => {
    const relativeTime = view.state.schema.marks.relative_time.create(settings);
    const node = view.state.schema.text(relativeTimeText).mark([relativeTime]);
    view.dispatch(view.state.tr.replaceSelectionWith(node, false));
});

export {createRelativeTime, createAndApplyRelativeTime}